import {arrowDownSvg as Icon__small__arrowDownSvg} from '../Icon__small/Icon__small--arrowDown.js'
import {arrowDownSvg as Icon__xsmall__arrowDownSvg} from '../Icon__xsmall/Icon__xsmall--arrowDown.js'

export var arrowDown = {
  name: 'arrowDown',
  category: 'icon',
  colorable: true,
  svg: Icon__small__arrowDownSvg,
  alt: {
    Icon__small: Icon__small__arrowDownSvg,
    Icon__xsmall: Icon__xsmall__arrowDownSvg
  },
  combined: ['Icon__small', 'Icon__xsmall']
};
